import { render, staticRenderFns } from "./manualTeacher.vue?vue&type=template&id=34e26663&"
import script from "./manualTeacher.vue?vue&type=script&lang=js&"
export * from "./manualTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports